export const fileToText = (file: File | Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => resolve(reader.result?.toString() ?? "");
    reader.onerror = (error) => reject(error);
  });
};

export const file2Base64 = (file: File | Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result?.toString().replace(/^data:(.*,)?/, "") ?? "";
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const fileListToObject = async (files?: File[]) => {
  if (!files || files.length === 0) {
    return [];
  }
  return await Promise.all(
    Array.from(files).map(async (file) => {
      return {
        base64: await file2Base64(file),
        name: file.name,
        type: file.type,
      };
    })
  );
};
